export default __webpack_public_path__ + "static/media/icons-audits.cadbc339.svg";